/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/dashboard/widgets/merklisten/dashboard.widgets.merklisten.component.ts.
 */
import {Component} from '@angular/core';
import {AppEventService} from '../../../../services/app.event.service';
import {AppMerklisteService} from '../../../../services/app.merkliste.service';

/**
 * Zweck: Beschreibt class DashboardWidgetsMerklistenComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'app-dashboard-widgets-merklisten',
    templateUrl: 'dashboard.widgets.merklisten.component.html',
    styleUrls: ['dashboard.widgets.merklisten.component.scss'],
    standalone: false
})
export class DashboardWidgetsMerklistenComponent {
  static id = 'DashboardWidgetsMerklistenComponent';
  static cols = 3;
  static rows = 5;
  static label = 'Ihre Merklisten';
  static description = 'Zeigt eine Liste ihrer Merklisten an.';

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public svc: AppMerklisteService, private esvc: AppEventService) {
  }

}
